<div class="student-tab div-imbrication">

    <!-- Réservations -->
    <div *ngIf="users.length > 0">
        <registration-booking *jhiHasAnyAuthority="['ROLE_ADMIN', 'ROLE_SALE']" [companies]="tsCompanies" [session]="session" [trainingSession]="trainingSession"
                              [users]="users" [usersNames]="usersNames">
        </registration-booking>
    </div>
    <!-- Titre récapitulatif stagiaires confirmés -->
    <div class="row" *jhiHasAnyAuthority="['ROLE_ADMIN', 'ROLE_SALE']">
        <div style="padding-top: 30px;" class="col-sm-12"><h3>Stagiaires confirmés</h3></div>
    </div>
    <div class="row" *ngIf="tsCompaniesLoading"><span class="col-sm-12">Chargement...</span></div>
    <div class="row" *ngIf="!tsCompaniesLoading">
        <div class="col-sm-8 select-all" *jhiHasAnyAuthority="'ROLE_ADMIN'">
            <input (ngModelChange)="toggleRegistrations()"
                   [(ngModel)]="areAllSelected"
                   [ngModelOptions]="{standalone: true}" class="checkbox-trainer" type="checkbox"
                   aria-label="checkbox-trainer" id="select_all">
            <label for="select_all">Tout sélectionner</label>
        </div>
        <div class="col-sm-8" *jhiHasAnyAuthority="'!ROLE_ADMIN'"></div>
        <div class="col-sm-4 totals">
            <span class="total-count {{getRoomSizeWarning()}}"
                 *ngIf="getCountRegistration() === 0">Aucun stagiaire</span>
            <span class="total-count {{getRoomSizeWarning()}}" *ngIf="getCountRegistration() === 1">1 stagiaire</span>
            <span class="total-count {{getRoomSizeWarning()}}" *ngIf="getCountRegistration() > 1">{{getCountRegistration()}} stagiaires</span>
            <span class="room-size {{getRoomSizeWarning()}}"
                  *ngIf="getRoomCapacity().length > 0">({{getRoomCapacity()}})</span>
            <span class="total-price">{{getTotalRegistration()}}</span>
        </div>
    </div>

    <!-- Liste des companies -->
    <div *ngFor="let company of tsCompanies" class="div-imbrication">
        <div class="row company-block">
            <registration-company [tsCompany]="company"
                                  [tsCompanies]="tsCompanies"
                                  [session]="session" class="registration-block">‡
            </registration-company>
        </div>
    </div>

    <div *ngIf="showCreateCompanyPanel" class="div-imbrication">
        <div class="row company-block">
            <registration-company (create)="companyCreated($event)"
                                  [tsCompanies]="tsCompanies"
                                  [session]="session" class="registration-block">
            </registration-company>
        </div>
    </div>

    <div *ngIf="!tsCompaniesLoading" class="col-sm-12">
        <span (click)="addCompany()" class="add-company" *jhiHasAnyAuthority="'ROLE_ADMIN'">
            <i class="fa fa-plus-circle"></i> Ajouter une entreprise
        </span>
    </div>

</div>

<!-- Boutons d'action de génération de documents - debut -->
<document-generation [session]="session" [sessionId]="sessionId" [tsCompanies]="tsCompanies"
                     [areAllSelected]="areAllSelected" [isOneElementSelected]="isOneElementSelected">
</document-generation>
<!-- Boutons d'action de génération de documents - fin -->



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/registration/registration.component.html